<template>
    <ModalContainer
        :isOpened="isOpen"
        :title="debugData?.title"
        :wide="true"
        data-interface-section="debug-dialog"
        @closeModal="debugDialogStore.closeDebugDialog"
    >
        <template #custom-content>
            <pre :class="$style.body">{{ formatted }}</pre>
        </template>
    </ModalContainer>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import ModalContainer from '@/components_new/ModalItems/ModalContainer.vue'
import { useDebugDialogStore } from '@/store/debug-dialog-store'

const debugDialogStore = useDebugDialogStore()
const { isOpen, debugData } = storeToRefs(debugDialogStore)

const formatted = computed(() => (debugData.value?.data ? JSON.stringify(debugData.value.data, null, 2) : ''))
</script>

<style module>
.body {
    white-space: pre-wrap;
    font-family: monospace;
    font-size: 14px;
    line-height: 1.5;
    max-height: 60vh;
    overflow-y: auto;
}
</style>
